import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";
let contactIndex = () => import(/* webpackChunkName: "contact" */ '@/views/pages/contact/Index');
let contactEdit = () => import(/* webpackChunkName: "contact" */ '@/views/pages/contact/Edit');
let contactCreate = () => import(/* webpackChunkName: "contact" */ '@/views/pages/contact/Create');
let faqIndex = () => import(/* webpackChunkName: "faq" */ '@/views/pages/faq/Index');
let faqCreate = () => import(/* webpackChunkName: "faq" */ '@/views/pages/faq/Create');
let faqCategories = () => import(/* webpackChunkName: "faq" */ '@/views/pages/faq/Categories');
let ceoIndex = () => import(/* webpackChunkName: "ceo" */ '@/views/pages/ceo/Index');
let ceoEdit = () => import(/* webpackChunkName: "ceo" */ '@/views/pages/ceo/Edit');
let tenderTerms = () => import(/* webpackChunkName: "tender" */ '@/views/pages/tender/Terms');
let plans = () => import(/* webpackChunkName: "plans" */ '@/views/pages/plans/Index');
let plansCreate = () => import(/* webpackChunkName: "plans" */ '@/views/pages/plans/Create');
let plansEdit = () => import(/* webpackChunkName: "plans" */ '@/views/pages/plans/Edit');

export default [
    ...prefix("/pages",[
        {
            path: "contacts",
            name: "contacts.index",
            component: contactIndex,
            meta: {
                middleware: web,
                permissions: ['unit-contacts:viewAny'],
                title: "اطلاعات تماس"
            }
        },
        {
            path: "contacts/:id",
            name: "contacts.edit",
            component: contactEdit,
            meta: {
                middleware: web,
                permissions: ['unit-contacts:update'],
                title: "ویرایش اطلاعات تماس"
            }
        },
        {
            path: "contacts/create",
            name: "contact.create",
            component: contactCreate,
            meta: {
                middleware: web,
                permissions: ['unit-contacts:create'],
                title: "ایجاد اطلاعات تماس"
            }
        },
        {
            path: "faqs",
            name: "faqs.index",
            component: faqIndex,
            meta: {
                middleware: web,
                permissions: ['faqs:viewAny'],
                title: "سوالات متداول"
            }
        },
        {
            path: "faqs/create",
            name: "faqs.create",
            component: faqCreate,
            meta: {
                middleware: web,
                permissions: ['faqs:create'],
                title: "ایجاد سوال متداول"
            }
        },
        {
            path: "faqs/categories",
            name: "faqs.categories.index",
            component: faqCategories,
            meta: {
                middleware: web,
                permissions: ['faq-categories:viewAny'],
                title: "دسته بندی سوالات متداول"
            }
        },
        {
            path: "ceo",
            name: "ceo.index",
            component: ceoIndex,
            meta: {
                middleware: web,
                permissions: ['ceo-contacts:viewAny'],
                title: "درخواست ارتباط با ریاست"
            }
        },
        {
            path: "ceo/:id",
            name: "ceo.edit",
            component: ceoEdit,
            meta: {
                middleware: web,
                permissions: ['ceo-contacts:update','ceo-contacts:view'],
                title: "نمایش درخواست"
            }
        },
        {
            path: "tender",
            name: "tender.terms",
            component: tenderTerms,
            meta: {
                middleware: web,
                permissions: ['settings:tenderTerms'],
                title: "شرایط مناقصه"
            }
        },
        {
            path: "plans",
            name: "plans.index",
            component: plans,
            meta: {
                middleware: web,
                permissions: ['plans:viewAny'],
                title: "طرح کانون"
            }
        },
        {
            path: "plans/create",
            name: "plans.create",
            component: plansCreate,
            meta: {
                middleware: web,
                permissions: ['plans:create'],
                title: " ایحاد طرح کانون"
            }
        },
        {
            path: "plans/:id",
            name: "plans.edit",
            component: plansEdit,
            meta: {
                middleware: web,
                permissions: ['plans:update','plans:view'],
                title: "   طرح کانون"
            }
        },
        ])
    ]
